import { alertFailure, errorText, ShownError } from "../../utils/error-messages";

export const initProfileEditDialogAvailability = () => {
  const dialogAvailability = document.getElementById("dialog-availability") as HTMLDialogElement;

  if (!dialogAvailability) {
    return;
  }

  const buttonSaveAvailability = dialogAvailability.querySelector(
    "button.save-availability",
  ) as HTMLButtonElement;
  const spinner = buttonSaveAvailability.querySelector(".spinner") as HTMLSpanElement;
  const success = buttonSaveAvailability.querySelector(".success") as HTMLSpanElement;

  buttonSaveAvailability.addEventListener("click", (event) => {
    event.preventDefault();

    buttonSaveAvailability.disabled = true;
    spinner.classList.remove("d-none");

    const availabilities: NodeListOf<HTMLInputElement> =
      dialogAvailability.querySelectorAll(".availability input");
    const formData = new FormData();

    availabilities.forEach((checkbox) => {
      formData.append(checkbox.name, checkbox.checked ? "true" : "false");
    });

    fetch("/website-api/users/availability/", {
      credentials: "same-origin",
      method: "post",
      body: formData,
    })
      .then((response) => {
        buttonSaveAvailability.disabled = false;
        spinner.classList.add("d-none");

        if (response.status === 401) {
          throw new Error("Unauthorized");
        }
        if (response.status === 429) {
          throw new ShownError(errorText("rateLimited"));
        }
        if (response.status === 500) {
          throw new Error("Service is unavailable");
        }

        return response.json();
      })
      .then((jsonResponse) => {
        if (jsonResponse.metadata.code >= 400) {
          if (jsonResponse.metadata.errors) {
            alert(jsonResponse.metadata.errors[0].error);

            return;
          }

          if (jsonResponse.metadata.error_message) {
            alert(jsonResponse.metadata.error_message);

            return;
          }

          alert(errorText("generic"));

          return;
        }

        success.classList.remove("d-none");

        setTimeout(() => {
          dialogAvailability.close();
        }, 400);
      })
      .catch(alertFailure);
  });
};
